@if (displayedData(); as tooltip) {
    <div
        class="chart-tooltip"
        role="tooltip"
        (pointerenter)="handlePointerEnter()"
        (pointerleave)="handlePointerLeave()"
        [class.horizontal-left]="tooltip.horizontalAlign === 'left'"
        [class.horizontal-right]="tooltip.horizontalAlign === 'right'"
        [class.vertical-above]="tooltip.verticalAlign === 'above'"
        [class.vertical-below]="tooltip.verticalAlign === 'below'"
        [style.left.px]="tooltip.x"
        [style.top.px]="tooltip.y"
    >
        <div class="tooltip-title font-semibold">{{ tooltip.title }}</div>

        <div class="tooltip-summary">
            @for (row of tooltip.summary; track $index) {
                <div class="tooltip-summary-row">
                    <div class="tooltip-label">
                        @if (row.color) {
                            <span class="tooltip-color" [style.background-color]="row.color"></span>
                        }
                        <span>{{ row.label }}</span>
                    </div>
                    <div class="tooltip-value">{{ row.value }}</div>
                </div>
            }
        </div>

        @if (tooltip.table; as table) {
            <div class="tooltip-table-container">
                <table class="tooltip-table">
                    <thead>
                        <tr>
                            @for (column of table.columns; track $index) {
                                <th [class.text-right]="column.align === 'right'">{{ column.label }}</th>
                            }
                        </tr>
                    </thead>
                    <tbody>
                        @for (row of table.rows; track $index) {
                            <tr>
                                @for (value of row; track $index) {
                                    <td [class.text-right]="table.columns[$index]?.align === 'right'">{{ value }}</td>
                                }
                            </tr>
                        }
                    </tbody>
                </table>
            </div>
        }
    </div>
}
